 <template>
    <div>
        <div class="container">
            <div class="row">
                <div class="col s12">
                    <div class="card-panel">
                        <div class="row">
                            <div class="col s12 m3">
                                <select v-model="type" class="browser-default">
                                    <option value="2" selected>Contact Number</option>
                                    <option value="3">Email Address</option>
                                </select>
                            </div>
                            <div class="col s12 m7">
                                <input id="search" v-model="searchField" type="text" placeholder="Search for information here">
                            </div>
                            <div class="col s12 m2">
                                <a v-if="!is_loading" class="waves-effect waves-light btn search-btn" v-on:click="getSearchWarrantyList">Search</a>
                                <a v-if="is_loading" class="btn disabled search-btn"><i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row" v-if="user">
                <div class="col s12 center-align hide-on-large-only" style="margin-top: 25px">
                    <svg id="barcode" v-bind:jsbarcode-value="user.id">
                    </svg>
                </div>
                <div class="col s12">
                    <table class="striped">
                        <tbody>
                        <tr>
                            <td class="title"><b>Member ID</b></td>
                            <td>{{ user.id }}</td>
                        </tr>
                        <tr>
                            <td class="title"><b>Name</b></td>
                            <td>{{ user.name }}</td>
                        </tr>
                        <tr>
                            <td class="title"><b>Email</b></td>
                            <td>{{ user.email }}</td>
                        </tr>
                        <tr>
                            <td class="title"><b>Phone No</b></td>
                            <td>{{ user.phone_no }}</td>
                        </tr>
                        <tr>
                            <td class="title"><b>Account Created At</b></td>
                            <td>{{ user.formatted_date }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row" v-if="is_no_user">
                <div class="col s12" >
                    <div class="card-panel center-align">
                        Sorry, user not found. <br>
                        Dont have an account yet? <a :href="registerUrl">Register Now</a>.
                    </div>
                </div>
            </div>
        </div>
        <warranty-table v-if="warranties.length > 0" :warranties="warranties"></warranty-table>
    </div>
</template>

<script>
    import WarrantyTableComponent from '../partials/WarrantyTableComponent';

    export default {
        name: "SearchComponent",
        props: [
            'siteUrl',
            'getWarrantySearchUrl',
            'getUserSearchUrl',
            'registerUrl'
        ],
        components: {
            'warranty-table': WarrantyTableComponent
        },
        data() {
            return {
                warranties: [],
                searchField: '',
                type: 2,
                is_loading: false,

                user: '',
                is_no_user: false,
            }
        },
        mounted () {

        },
        methods: {
            getSearchWarrantyList()
            {
                if (!this.searchField) {
                    return;
                }
                let me = this;
                this.is_loading = true;
                axios.get(this.getWarrantySearchUrl, {
                    params: {
                        type: this.type,
                        searchField: this.searchField
                    }
                }).then(function (response) {
                    me.warranties = response.data.warranties;
                    me.is_loading = false;
                }).catch(function (error){
                    if (error.response.status == 422) {
                        alert('Please provide an input');
                    }
                    me.is_loading = false;
                });

                this.getSearchUserList();
            },
            getSearchUserList: function () {

                this.is_no_user = false;

                if (!this.searchField) {
                    return;
                }
                let me = this;
                this.is_loading = true;
                axios.get(this.getUserSearchUrl, {
                    params: {
                        type: this.type,
                        searchField: this.searchField
                    }
                }).then(function (response) {

                    me.user = response.data.user;

                    me.generateBarCode();

                    if (me.user) {
                        me.is_no_user = false
                    }
                    else {
                        me.is_no_user = true
                    }

                    me.is_loading = false;
                }).catch(function (error){
                    console.log(error);
                    if (error.response.status == 422) {
                        alert('Please provide an input');
                    }
                    me.is_loading = false;
                });
            },
            generateBarCode: function () {
                $(document).ready(function() {
                    JsBarcode("#barcode").init();
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .title {
        text-align: center;
    }
</style>
